import type { WidgetIntervalType } from '@/dashboard/shared/types/widgets.types';

/**
 * interval에 따른 timeFormat과 interval(time 포함) 반환
 * @param interval e.g 'I5s', 'I1m', 'I10m', 'I1h', 'I1d'
 */
export const getCategoryTimeAxisInfoByInterval = (
  interval: WidgetIntervalType | (string & {}),
): {
  timeFormat: string;
  interval: { unit: 'second' | 'minute' | 'hour' | 'day'; time: number };
} => {
  const getTimeFromInterval = (intervalStr: string) => {
    const match = intervalStr.match(/\d+/);
    return match ? parseInt(match[0], 10) : 1;
  };

  switch (interval) {
    case 'I1d':
    case 'I24h':
      return {
        timeFormat: 'DD HH:mm',
        interval: {
          unit: 'day',
          time: 1,
        },
      };
    case 'I1h':
    case 'I2h':
    case 'I5h':
      return {
        timeFormat: 'HH:mm',
        interval: {
          unit: 'hour',
          time: getTimeFromInterval(interval),
        },
      };
    case 'I1m':
    case 'I3m':
    case 'I5m':
    case 'I10m':
    case 'I15m':
    case 'I20m':
    case 'I30m':
      return {
        timeFormat: 'HH:mm',
        interval: {
          unit: 'minute',
          time: getTimeFromInterval(interval),
        },
      };
    case 'I100ms':
    case 'I5s':
    case 'I3s':
    case 'I1s':
    case 'I10s':
    case 'I15s':
    case 'I30s':
    default:
      return {
        timeFormat: 'HH:mm:ss',
        interval: {
          unit: 'second',
          time: getTimeFromInterval(interval),
        },
      };
  }
};
